var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iv2-pagetop theme__pagetop d-none d-xl-block text-center",on:{"click":_vm.scrollTop}},[_c('span',[_vm._v(_vm._s(_vm.$store.state.themeLang.general.page_top)),_c('i',{staticClass:"fas fa-chevron-up ml-4"})])])}
var staticRenderFns = []

export { render, staticRenderFns }